import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import { MenuListItemsSignOut, MenuListItemsAddressSignOut } from './SideMenuData';

const styles = {
    list: {
        width: 280,
    },
    fullList: {
        width: 'auto',
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 0,
    },
};

class SideMenu extends Component {

    constructor (props) {
        super(props)
        this.state = {
            left: false,
        };
    }

    toggleDrawer = (side, open) => () => {
        this.setState({[side]: open,});
    };

    render() {
        const { classes, cookies } = this.props;
        const supportedPersonId = cookies.get('supportedPersonId');
        const supporterFullName = cookies.get('supporterFullName');
        const addressFlg = cookies.get('AVAILABLE_ADDRESS');
        //01 : 未ログイン状態のためログアウトボタンがサイドメニューに描画されない
        //02 : ログイン状態のため、ログアウトボタンが表示される。
        let sideMenuFlg = "";
        if(supportedPersonId === "" || supportedPersonId === undefined ||
            supporterFullName === "" || supporterFullName === undefined ){
            sideMenuFlg = "01";
        }
        else if(addressFlg === 'TRUE'){
            sideMenuFlg = "02";
        }
        else{
            sideMenuFlg = "03";
        }
        return (
        <div>
            {sideMenuFlg !== "01" &&
                <>
                    <IconButton
                        className={classes.menuButton}
                        color="inherit"
                        onClick={this.toggleDrawer('left', true)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <SwipeableDrawer
                        open={this.state.left}
                        onClose={this.toggleDrawer('left', false)}
                        onOpen={this.toggleDrawer('left', true)}
                    >
                    <div>
                        <div className={classes.list}>
                            {sideMenuFlg === "02" && <MenuListItemsAddressSignOut />}
                            {sideMenuFlg === "03" && <MenuListItemsSignOut />}
                        </div>
                    </div>
                    </SwipeableDrawer>
                </>
            }
        </div>
        );
    }
}

//値の検証
SideMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withCookies(SideMenu));